import React, {Component} from 'react';
import Action from '../actions';
import {connect} from 'react-redux';

class CheckLineup extends Component {
    onCheck(isChecked) {
        const {lineupId} = this.props;
        this.props.dispatch(Action.do('checkLineup', lineupId, isChecked));
    }

    render() {
        const {lineupId, lineups, sportConfig} = this.props;
        const lineup = lineups.getLineup(lineupId);

        if (!lineup || sportConfig.isModeLateswap()) {
            return null;
        }

        return <input type="checkbox" checked={lineup.checked} onChange={(e) => ::this.onCheck(e.target.checked)} />;
    }
}

function mapStatesToProps(state) {
    const {
        sportConfig,
        lineupsData: {lineups},
    } = state;

    return {
        sportConfig,
        lineups,
    };
}

export default connect(mapStatesToProps)(CheckLineup);
